import React from 'react';
import PropTypes from 'prop-types';

// CONSTANTS
import {
  ROUTE_DISCOVER_MOVIE,
  ROUTE_DISCOVER_SHOW,
  ROUTE_SHOWS_AND_MOVIES_MOVIE,
  ROUTE_SHOWS_AND_MOVIES_SHOW,
} from '@/constants/routes';
import { ContentType } from '@/constants/watchList';

// UTILITY
import { getLink } from '@/utility/routes';

// COMPONENTS
import RouterLink from '@/components/Link';

// STYLES
import { DetailsButtonStyled } from '../styles';

function DetailsButton({ data, hasStreamingData, ...props }) {
  const { type } = data;
  const isShowMoviesMovieRoute =
    type === (typeof type === 'string' ? ContentType.MOVIE : ContentType.MOVIE_ID);
  const isShowMoviesShowRoute =
    type === (typeof type === 'string' ? ContentType.SHOW : ContentType.SHOW_ID);

  const movieLink = getLink(
    isShowMoviesMovieRoute ? ROUTE_SHOWS_AND_MOVIES_MOVIE : ROUTE_DISCOVER_MOVIE,
    { movie_id: data.slug || data.id },
  );

  const showLink = getLink(
    isShowMoviesShowRoute ? ROUTE_SHOWS_AND_MOVIES_SHOW : ROUTE_DISCOVER_SHOW,
    { show_id: data.slug || data.id },
  );

  const pathname = isShowMoviesShowRoute ? showLink : movieLink;

  const linkProps = {
    component: RouterLink,
    to: pathname,
  };

  if (hasStreamingData) {
    linkProps.state = {
      streamingDataFetched: true,
    };
  }

  return <DetailsButtonStyled {...props} {...linkProps} />;
}

DetailsButton.propTypes = {
  data: PropTypes.object.isRequired,
  hasStreamingData: PropTypes.bool,
};

export default React.memo(DetailsButton);
